import axios from 'axios';
import colors from 'vuetify/lib/util/colors'
import { DEPLOYMENT_STATUS_ONLINE,
  DEPLOYMENT_STATUS_OFFLINE,
  DEPLOYMENT_STATUS_PENDING,
  DEPLOYMENT_STATUS_ASKED,
  DEPLOYMENT_STATUS_FAILED,
} from '@/config/constants.js';

export default {
  getDeployment(projectId, deploymentId) {
    const url = `${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/deployments/${deploymentId}`;
    return axios.get(url);
  },

  listDeployments(projectId, sortBy = 'lastModifiedDate', sortDesc = [true], page = 0, itemsPerPage = 10) {
    if (sortBy.length === 0) {
      sortBy = 'lastModifiedDate';
    }

    if (sortDesc.length === 0) {
      sortDesc[0] = true;
    }
    const sortType = sortDesc[0] ? 'desc' : 'asc';

    const url = `${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/deployments?sort=${sortBy},${sortType}&page=${page}&pageSize=${itemsPerPage}`;
    return axios.get(url);
  },

  deploy(projectId, payload) {
    const url = `${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/deployments`;
    return axios.post(url, payload);
  },

  undeploy(projectId, deploymentId) {
    const url = `${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/deployments/${deploymentId}`;
    return axios.delete(url);
  },

  getAvailableStages(projectId) {
    const url = `${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/deployments/stages`;
    return axios.get(url);
  },
  statusColor(deploymentStatus) {
      var choosenColor; 
      switch(deploymentStatus) {
        case DEPLOYMENT_STATUS_ONLINE:
          choosenColor = colors.green.accent4;
          break;
        case DEPLOYMENT_STATUS_ASKED:
          choosenColor = colors.orange.lighten4;
          break;
        case DEPLOYMENT_STATUS_PENDING:
          choosenColor = colors.orange.lighten2;
          break;
        case DEPLOYMENT_STATUS_OFFLINE:
          choosenColor = colors.grey.lighten1;
          break;
        case DEPLOYMENT_STATUS_FAILED:
          choosenColor = colors.red.accent4;
          break;
        default:
          // default when not deployed
          choosenColor = colors.lightBlue.lighten4;
      }
      return choosenColor;
    },

};
